export const extractMessageFromError = (error: unknown): string | undefined => {
    if (typeof error === 'string') {
        return error;
    }

    const message =
        // this check includes Error instances and all other based on Error (e.g. VideoClientError)
        error instanceof Error ? error.message : undefined;

    return message;
};
